import React, { Component } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Styles from '../../../GeneralUI/Styles';
import { Paper, InputLabel, Grid, Table, TableHead, TableRow, TableCell, TableBody } from '@material-ui/core';
import { search } from '../../../../Actions/General';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { TextField, Button } from '@material-ui/core';
import { SnackbarProvider, withSnackbar } from 'notistack';
import { saveCustom } from './../../../../Actions/General'
import { errorSetter } from '../../../../Libs';
import PSelect from '../../../GeneralUI/PSelect'
import to from 'await-to-js';
import _ from 'lodash';
import { Line, Pie, Bar } from "react-chartjs-2";
import AutoComplete from '../../../GeneralUI/AutoComplete';

import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Row,
  Col
} from "reactstrap";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';


class IndicadoresComerciales extends Component {
  constructor(props) {
    super(props);

    this.setErrors = errorSetter.setErrors.bind(this);
  }

  state = {
    result: {     
    },
    filters: {
      TIPO_INFORME:null,
      FECHA_INICIAL_SERVICIO:null,
      FECHA_FINAL_SERVICIO:null,
      COMERCIAL_CODIGO:null, 
      ESTADO_CODIGO:null, 
      SUCURSAL_CODIGO:null
    },
    tipoGrafico:'Line'
  };

  componentDidMount() {
    this.props.toggleFavorites();
  }

  componentWillUnmount() {
    this.props.toogleFavoritesShow();
  }

  search = async (page, rowsPerPage) => {
 await saveCustom({ values: this.state.filters }, '/processes/getindicador').then(result => {
  
  // --- PRUEBA 1: ¿Qué viene exactamente del Backend? ---
  // console.log("1. DATA CRUDA DEL BACKEND:", result);

  const baseOptions = result.options || {};

  let updatedYAxes = [];
  if (baseOptions.scales && baseOptions.scales.yAxes) {
    updatedYAxes = baseOptions.scales.yAxes.map((axis, idx) => {
      // console.log(`2. Auditando Eje Y [${idx}] original:`, axis); // --- PRUEBA 2 ---
      return {
        ...axis,
        ticks: {
          ...(axis.ticks || {}),
          beginAtZero: true,
          userCallback: function(value) {
            return new Intl.NumberFormat('es-CO').format(value);
          },
          callback: function(value) {
            return new Intl.NumberFormat('es-CO').format(value);
          }
        }
      };
    });
  } else {
    // console.log("2. ALERTA: El backend NO envió scales.yAxes. Creando eje por defecto.");
    updatedYAxes = [{
      ticks: {
        beginAtZero: true,
        callback: function(value) {
          return new Intl.NumberFormat('es-CO').format(value);
        }
      }
    }];
  }

  const extendedOptions = {
    ...baseOptions,
    scales: {
      ...baseOptions.scales,
      yAxes: updatedYAxes
    },
    tooltips: {
      ...(baseOptions.tooltips || {}),
      mode: 'index',
      intersect: false,
      callbacks: {
        label: function(tooltipItem, data) {
          const dataset = data.datasets[tooltipItem.datasetIndex];
          const value = tooltipItem.yLabel !== undefined ? tooltipItem.yLabel : tooltipItem.xLabel;

          // --- PRUEBA 3: ¿El tooltip está ejecutando la función? ---
          // console.log("3. Valor detectado en Tooltip:", value, "Tipo Dataset:", dataset.type);

          if (dataset.type === 'line') {
            return dataset.label + ': ' +
              new Intl.NumberFormat('es-CO', {
                style: 'currency',
                currency: 'COP',
                minimumFractionDigits: 0
              }).format(value);
          }

          return dataset.label + ': ' + new Intl.NumberFormat('es-CO').format(value);
        }
      }
    }
  };

  this.setState({
    result: {
      ...result,
      options: extendedOptions
    }
  }, () => {
    // --- PRUEBA 4: ¿El estado final de React tiene las funciones inyectadas? ---
    // console.log("4. ESTADO FINAL DE EN REACT (options):", this.state.result.options);
  });

}).catch(error => {
  this.props.enqueueSnackbar(error.errorMessage || 'Error al cargar indicadores', { variant: 'error' });
});

  }

  exportToExcel = () => {
  const raw = this.state.result?.raw;
  if (!raw || !raw.length) return;

  const worksheet = XLSX.utils.json_to_sheet(raw);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Indicadores");

  const excelBuffer = XLSX.write(workbook, {
    bookType: 'xlsx',
    type: 'array'
  });

  const data = new Blob([excelBuffer], {
    type: 'application/octet-stream'
  });

  saveAs(data, "Indicadores.xlsx");
};

  setDataValidation = (errorForm, errorMessage) => {
    this.setState({ errorForm: errorForm, errorMessage: errorMessage });
  }

  handleChange = (event) => {

    let { filters } = this.state;
    const caret = event.target.selectionStart;
    const element = event.target;
    if (element.hasOwnProperty('setSelectionRange')) {
      window.requestAnimationFrame(() => {
        element.setSelectionRange(caret, caret);
      });
    }

    if (event.target.type === 'time') {
      filters[event.target.id] = event.target.value;
    } else if (event.target.type === 'number') {
      filters[event.target.id] = event.target.value;
    } else {
      filters[event.target.id] = event.target.value.toUpperCase();
    }

    if (filters[event.target.id] === '') {
      filters[event.target.id] = null;
    }

    if (event.target.id === 'TIPO_INFORME') {
      this.state.result.data=null;
      if(filters[event.target.id]=='TOTAL VENTAS'){
        this.setState({ tipoGrafico: 'Line' });
      }
      if(filters[event.target.id]=='OTRO' || filters[event.target.id] == 'ASESOR X SERVICIOS Y VALOR' || filters[event.target.id] == 'ASESOR NUMERO SERVICIOS Y VALOR'  || filters[event.target.id] == 'AUXILIAR DE VENTAS X SERVICIOS Y VALOR'){
        this.setState({ tipoGrafico: 'Bar' });
      }
      if(filters[event.target.id]=='TOTAL PEDIDOS'){
        this.setState({ tipoGrafico: 'Pie' });
      }
    }

    this.setState(filters);
  }

  renderTable = () => {
      const raw = this.state.result?.raw;

      if (!Array.isArray(raw) || raw.length === 0) {
        return null;
      }

      const columns = Object.keys(raw[0]);

      return (
        <Table>
          <TableHead>
            <TableRow>
              {columns.map(col => (
                <TableCell key={col}><b>{col}</b></TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {raw.map((row, i) => (
              <TableRow key={i}>
                {columns.map((col) => {
                  const value = row[col];
                  
                  // Verificamos si es un número real
                  const isNumber = typeof value === 'number';

                  return (
                    <TableCell key={col} align={isNumber ? "right" : "left"}>
                      {isNumber 
                        ? new Intl.NumberFormat('es-CO').format(value) 
                        : value}
                    </TableCell>
                  );
                })}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      );
    }


  render() {
    return (
      <Paper elevation={5} className={`${this.props.classes.mainPaper} ${this.props.classes.fullWidthPaper}`}>
        <Grid container spacing={4}>
          <Grid item xs={3} className={this.props.classes.gridForm}>
            <InputLabel className={this.props.classes.tittleLabelForm}>
            Indicadores Comerciales 
              </InputLabel>
          </Grid>
        </Grid>

        <Grid container spacing={2}>   
            <Grid item xs={3} className={this.props.classes.gridForm}>
              <PSelect
                  id="TIPO_INFORME"
                  useChildren={true}
                  value={this.state.filters["TIPO_INFORME"]}
                  onChange={this.handleChange}
                  namelabel="Tipo Informe"
                >
                <option value="TOTAL VENTAS">TOTAL VENTAS</option>
                <option value="ASESOR X SERVICIOS Y VALOR">ASESOR X SERVICIOS Y VALOR</option>
                <option value="AUXILIAR DE VENTAS X SERVICIOS Y VALOR">AUXILIAR DE VENTAS X SERVICIOS Y VALOR</option>                
                <option value="ASESOR NUMERO SERVICIOS Y VALOR">ASESOR NUMERO SERVICIOS Y VALOR</option>
              </PSelect>
            </Grid>  
            <Grid item xs={3} className={this.props.classes.gridForm}>
              <TextField
                id="FECHA_INICIAL_SERVICIO"
                fullWidth
                margin="normal"
                variant="outlined"
                onChange={this.handleChange}
                value={this.state.filters["FECHA_INICIAL_SERVICIO"]}
                type="date"
                label="FechaServicio Inicial"
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={3} className={this.props.classes.gridForm}>
              <TextField
                id="FECHA_FINAL_SERVICIO"
                fullWidth
                margin="normal"
                variant="outlined"
                onChange={this.handleChange}
                value={this.state.filters["FECHA_FINAL_SERVICIO"]}
                type="date"
                label="FechaServicio Final"
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
        </Grid>

        <Grid container spacing={4}>
          <Grid item xs={3} className={this.props.classes.gridForm}>
            <AutoComplete
              id="SUCURSAL_CODIGO"
              tableName='Sucursal'
              fields={['sucursalCodigo', 'sucursalNombre']}
              primaryField='sucursalCodigo'
              aliases={['ID', 'Nombre']}
              searchField='sucursalNombre'
              placeHolder='Sucursal'
              onSelect={this.handleChange}
              value={this.state.filters["sucursalCodigo"]}
            />
          </Grid>
          <Grid item xs={3} className={this.props.classes.gridForm}>
            <AutoComplete
              id="COMERCIAL_CODIGO"
              tableName='Comercial'
              fields={['comercialCodigo', 'comercialNombreCompleto']}
              primaryField='comercialCodigo'
              aliases={['ID', 'Nombre']}
              searchField='comercialNombreCompleto'
              placeHolder='Comercial'
              onSelect={this.handleChange}
              value={this.state.filters["COMERCIAL_CODIGO"]}
            />
          </Grid>
          <Grid item xs={3} className={this.props.classes.gridForm}>
            <PSelect
              id="ESTADO_CODIGO"
              useChildren={true}
              value={this.state.filters["ESTADO_CODIGO"]}
              onChange={this.handleChange}
              namelabel="Estado"
            >
              <option value="EFECTIVAS">EFECTIVAS</option>                
              <option value="PROSPECTOS">PROSPECTOS</option>
              <option value="EFECTIVAS + PROSPECTOS">EFECTIVAS + PROSPECTOS</option>
              <option value="FACTURADO">FACTURADO</option>
              <option value="DESPACHADO">DESPACHADO</option>
              <option value="CONFIRMADO">CONFIRMADO</option>
              <option value="COTIZADO">COTIZADO</option>
              <option value="PENDIENTE">PENDIENTE</option>
            </PSelect>
          </Grid>
        </Grid>

        <Grid container spacing={10} >
          <Grid item xs={3} className={this.props.classes.gridForm}>

            <Button
              color='primary'
              variant='contained'
              onClick={(event) => this.search()}
            >
              Buscar
              </Button>

          </Grid>
          <Grid item xs={3} className={this.props.classes.gridForm}>
              <Button
                color='secondary'
                variant='contained'
                onClick={this.exportToExcel}
              >
                Exportar Excel
              </Button>
          </Grid>
        </Grid>

        <Row>
          <Col xs={12} sm={12} md={8}>
          <Card className="card-chart">
              <CardHeader>
                <CardTitle>Resultado:</CardTitle>
              </CardHeader>
              <CardBody>
                {(this.state.result.data) && this.state.tipoGrafico=='Line'?
                <Line
                  data={this.state.result.data}
                  options={this.state.result.options}
                  width={600}
                  height={200}
                />:null
                }

                {(this.state.result.data) && this.state.tipoGrafico=='Pie'?
                <Pie
                  data={this.state.result.data}
                  options={this.state.result.options}
                  width={600}
                  height={200}
                />:null
                }

                {(this.state.result.data) && this.state.tipoGrafico=='Bar'?
                <Bar
                  data={this.state.result.data}
                  options={this.state.result.options}
                  width={600}
                  height={200}
                />:null
                }

                {this.renderTable()}

              </CardBody>
            </Card>
          </Col>
        </Row>      
      </Paper>
    );
  }
}

IndicadoresComerciales.propTypes = {
  enqueueSnackbar: PropTypes.func.isRequired,
  toggleFavorites: PropTypes.func.isRequired,
  toogleFavoritesShow: PropTypes.func.isRequired
};

const MyApp = withRouter(withSnackbar(withStyles(Styles, { withTheme: true })(IndicadoresComerciales)));

function IntegrationNotistack(props) {
  return (
    <SnackbarProvider key={6} maxSnack={1}
      action={[
        <Button key={6} variant="text" color="primary" size="small">
          {'X'}
        </Button>
      ]}
    >
      <MyApp {...props} />
    </SnackbarProvider>
  );
}


export default IntegrationNotistack;